import { recipientAppConstants } from '../constants';
import { saveParams, deleteParams, createParams } from './base.reducers';

const name = 'recipientApps';

const initialState = {
	saveLoading: 0,
	saveSuccess: false,
	deleteLoading: 0,
	allLoading: 0,

	recipientApps: [],
	recipientAppsById: {}
};

export default (state = initialState, payload) => {
	const { type, data } = payload;
	switch (type) {
		// Save and edit apps
		case recipientAppConstants.SAVING_RECIPIENT_APP_REQUEST:
			return {
				...state,
				saveSuccess: false,
				saveLoading: state.saveLoading + 1,
			};
		case recipientAppConstants.SAVING_RECIPIENT_APP_SUCCESS:
			const { form } = data;
			return {
				...saveParams({ name, state, form }),
				saveLoading: state.saveLoading - 1,
				saveSuccess: true
			};
		case recipientAppConstants.SAVING_RECIPIENT_APP_FAILURE:
			return {
				...state,
				saveLoading: state.saveLoading - 1,
			};
		// Delete app
		case recipientAppConstants.DELETE_RECIPIENT_APP_REQUEST:
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		case recipientAppConstants.DELETE_RECIPIENT_APP_SUCCESS:
			const id = data;
			return {
				...deleteParams({ name, state, id }),
				deleteLoading: state.deleteLoading - 1
			};
		case recipientAppConstants.DELETE_RECIPIENT_APP_FAILURE:
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		// Load apps
		case recipientAppConstants.LOAD_RECIPIENT_APPS_REQUEST:
			return {
				...state,
				allLoading: state.allLoading + 1,
			};
		case recipientAppConstants.LOAD_RECIPIENT_APPS_SUCCESS:
			return {
				...createParams({ name, state, data: data.data }),
				allLoading: state.allLoading - 1
			};
		case recipientAppConstants.LOAD_RECIPIENT_APPS_FAILURE:
			return {
				...state,
				allLoading: state.allLoading - 1,
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/redux/reducers/recipientApp.reducers.js